import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import "@/common/init";
import router from "@/router";
import store from "@/store";
import ui from "@/ui";
import api from "@/api";
import request from "@/api/request";
import component from "@/components";
// import VConsole from "vconsole";
// new VConsole();

createApp(App).use(store).use(router).use(ui).use(request).use(api).use(component).mount("#app");
